var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUhf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34,
    fill: "#082026",
    stroke: "#082026",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5424 28.1565C17.5424 22.2963 22.2956 17.5422 28.1571 17.5422C31.1823 17.5422 33.906 18.8159 35.84 20.8475L37.7167 18.9709C35.3029 16.4585 31.9158 14.8887 28.1571 14.8887C20.8287 14.8887 14.8887 20.8305 14.8887 28.1565C14.8887 31.915 16.4586 35.302 18.9711 37.7167L20.8478 35.839C18.8151 33.9062 17.5424 31.1826 17.5424 28.1565Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0323 22.4403C29.6775 22.4403 31.1403 23.1638 32.1636 24.2944L34.1498 22.3083C32.6199 20.6734 30.448 19.6445 28.0323 19.6445C23.3989 19.6445 19.6445 23.402 19.6445 28.0317C19.6445 30.4472 20.6723 32.6189 22.3074 34.1498L24.2936 32.1638C23.1629 31.1394 22.4405 29.6756 22.4405 28.0317C22.4405 24.9452 24.9434 22.4403 28.0323 22.4403Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.072 19.6445H42.2895V22.9024H48.9633V27.2462H46.2128C45.9478 25.5554 44.4949 24.2544 42.7325 24.2544C40.7834 24.2544 39.1991 25.8399 39.1991 27.7892C39.1991 29.139 38.1001 30.238 36.7515 30.238C35.4788 30.238 34.4418 29.2585 34.3256 28.0151V27.2462H30.449C30.1971 26.0071 29.1025 25.0743 27.7897 25.0743C26.2901 25.0743 25.075 26.2906 25.075 27.7892C25.075 29.2878 26.2901 30.5041 27.7897 30.5041C29.1025 30.5041 30.1971 29.5712 30.449 28.3322H33.2723C33.5362 30.023 34.9902 31.324 36.7526 31.324C38.7017 31.324 40.286 29.7385 40.286 27.7892C40.286 26.4393 41.3849 25.3404 42.7336 25.3404C44.0844 25.3404 45.1833 26.4393 45.1833 27.7892L45.2007 28.3322H48.9633V48.9653H22.9022V42.2986H19.6445V50.0729C19.6445 51.261 20.6066 52.222 21.7935 52.222H50.0731C51.2588 52.222 52.222 51.2599 52.222 50.0729V21.7936C52.2209 20.6067 51.2578 19.6445 50.072 19.6445Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1087 42.3106C31.1087 42.7932 30.997 43.1603 30.7708 43.412C30.546 43.6637 30.233 43.7884 29.832 43.7884C29.4402 43.7884 29.1312 43.6626 28.9024 43.4086C28.6763 43.1569 28.5619 42.7897 28.5619 42.3106V37.7168H27.0156V42.3106C27.0156 43.1049 27.276 43.7284 27.7966 44.1763C28.3173 44.6266 28.9958 44.8506 29.832 44.8506C30.6722 44.8506 31.3533 44.6277 31.8766 44.1786C32.3999 43.7318 32.6615 43.1084 32.6615 42.3106V37.7168H31.1087V42.3106Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0275 37.7168V40.8001H36.4622V37.7168H34.9199V44.8506H36.4622V41.8774H39.0275V44.8506H40.5658V37.7168H39.0275Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.341 37.7168H42.8242V44.8506H44.3553V41.868H46.8648V40.7895H44.3553V38.7988H47.341V37.7168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUhf);
export default __webpack_public_path__ + "static/media/UHF.c3a5a2f04c7a645705e6d42e01d01a02.svg";
export { ForwardRef as ReactComponent };